import React, { useState } from "react";
import quizfrst from "../../../assets/headerpage-icon/quiz1.png";
import thankLogo from "../../../assets/headerpage-icon/thank-logo.png";
import quiz2 from "../../../assets/headerpage-icon/quiz2.png";
import quiz3 from "../../../assets/headerpage-icon/quiz3.png";
import quiz4 from "../../../assets/headerpage-icon/quiz4.png";
import quiz5 from "../../../assets/headerpage-icon/quiz5.png";
import quiz6 from "../../../assets/headerpage-icon/quiz6.png";
import quiz7 from "../../../assets/headerpage-icon/quiz7.png";
import quiz8 from "../../../assets/headerpage-icon/quiz8.png";
import quiz9 from "../../../assets/headerpage-icon/quiz9.png";
import quiz10 from "../../../assets/headerpage-icon/quiz10.png";
import { savequizdetails } from "../../../api/leads";
import { errorMessage, successMessage } from "../Util/Toaster";
import { CSpinner } from "@coreui/react";

export interface QuestionAnswer {
  selected: any;
  setIsModalOpen?: boolean;
  isModalOpen?: boolean;
}
const QuizStepper = (props: any) => {
  const { email, phone, user_name } = props.data;

  console.log("data in quizstepper", props.data);

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [quizSubmitted, setQuizSubmitted] = useState(false);
  const [spinLoading, setSpinLoading] = useState<boolean>(false);
  const [quiz, setQuiz] = useState([
    {
      question: "How do you prefer to communicate with your agent?",
      options: [
        "Quick updates by text or email",
        "Regular phone check-ins to talk things through",
        "Only when there’s something important to discuss",
      ],
      selected: null,
    },
    {
      question: "When it comes to big decisions, your style is...",
      options: [
        "I do my research and carefully weigh options",
        "I trust my instincts and move quickly",
        "I like expert guidance to help me choose",
      ],
      selected: null,
    },
    {
      question: "Which best describes your personality?",
      options: [
        "More introverted—I recharge with quiet time",
        "More extroverted—I enjoy being around people",
        "A mix—it depends on the day",
      ],
      selected: null,
    },
    {
      question: "The quality you value most in an agent is...",
      options: [
        "Strong negotiating skills to get the best deal",
        "Someone who listens and understands me",
        "Deep market knowledge and expert advice",
      ],
      selected: null,
    },
    {
      question: "What’s your weekend vibe?",
      options: [
        "Relaxing with family and friends",
        "Getting outside for an adventure",
        "Tackling creative or DIY projects",
      ],
      selected: null,
    },
    {
      question: "What’s your ideal timeline for buying or selling?",
      options: [
        "ASAP—I’m ready to move now",
        "Within the next 3–6 months",
        "No rush—waiting for the perfect fit",
      ],
      selected: null,
    },
    {
      question: "How comfortable are you with technology in the process?",
      options: [
        "Very—I love digital tools like virtual tours and e-signing",
        "Somewhat—I like a balance of digital and in-person",
        "Not very—I prefer a traditional, hands-on approach",
      ],
      selected: null,
    },
    {
      question: "What type of agent personality do you click with best?",
      options: [
        "Outgoing and energetic",
        "Direct and straightforward",
        "Easy-going and approachable",
      ],
      selected: null,
    },
    {
      question: "What motivates your move the most?",
      options: [
        "Finding a home that fits my lifestyle",
        "Maximizing the financial side of the deal",
        "Keeping the process smooth and stress-free",
      ],
      selected: null,
    },
    {
      question: "What kind of agent are you looking for?",
      options: [
        "Data-driven and fact-focused",
        "A supportive, empathetic advocate",
        "Someone who can handle everything for me",
      ],
      selected: null,
    },
  ]);

  const handleSelectOption = (index: any) => {
    const copy = [...quiz];
    copy[currentQuestion].selected = index;
    setQuiz(copy);
    setSelectedOption(index);
  };

  const checkSelection = () => {
    return quiz[currentQuestion].selected;
  };

  const nextQuestion = () => {
    if (checkSelection()) {
      if (currentQuestion < quiz.length - 1) {
        setScore(score + 1);
        setCurrentQuestion(currentQuestion + 1);
        storeSelectedOption();
      } else {
        storeSelectedOption();
        setSpinLoading(true);
        // alert("Quiz completed! Your answers have been saved.");
        const submittedForm = JSON.parse(
          localStorage.getItem("storedOptions") || ""
        );
        // const qustionAnser = submittedForm.map((obj: any) => ({ ...obj, answer: obj.selected }));
        // const qustionAnswer = submittedForm.map(({ selected: answer, ...rest }) => ({  answer, ...rest}));
        const qustionAnswer = submittedForm.map(
          ({ selected, ...rest }: QuestionAnswer) => ({
            answer: selected,
            ...rest,
          })
        );
        if (
          email != undefined ||
          phone != undefined ||
          user_name != undefined
        ) {
          let saveQuizPayload = {
            user_info: {
              name: user_name,
              email: email,
              phone: phone,
            },
            quizz_Question_info: qustionAnswer,
          };

          let res = savequizdetails(saveQuizPayload)
            .then((data) => {
              if (data?.data?.status == "success") {
                successMessage(data?.data?.message);
                setSpinLoading(false);
                setQuizSubmitted(true);
              } else {
                errorMessage(data?.data?.message);
                setSpinLoading(false);
              }
            })
            .catch((error) => console.error(error));
        }
      }
    } else {
      errorMessage(
        "Please select an option before moving on to the next question."
      );
      //   alert("Please select an option before moving on to the next question.");
    }
  };

  const storeSelectedOption = () => {
    localStorage.setItem(
      "storedOptions",
      JSON.stringify(quiz.map(({ options, ...rest }) => ({ ...rest })))
    );
  };

  const previousQuestion = () => {
    if (currentQuestion > 0) {
      setScore(score - 1);
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const optionLetters = ["A", "B", "C"];
  const renderOptions = () => {
    return quiz[currentQuestion].options.map((option, index) => (
      <div
        // className={`quiz-box ${option == selectedOption ? "active" : ""}`}
        className={`quiz-box ${
          quiz[currentQuestion].selected == option ? "active" : ""
        }`}
        key={index}
        onClick={() => handleSelectOption(option)}
      >
        <span className="inner">
          {optionLetters[index % optionLetters.length]}
        </span>{" "}
        <p>{option}</p>
      </div>
    ));
  };

  return (
    <>
      {!quizSubmitted ? (
        <div className="modal-form quiz-inner-body">
          <div className="row no-gutters">
            <div className="col-md-6">
              <div className="quiz-left h-100">
                <p className="text-center">Get Matched with an Agent</p>
                <div className="card-border">
                  <div className="card-border">
                    <img
                      src={quizfrst}
                      className={`img-fluid w-100 ${
                        score == 0 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                    <img
                      src={quiz2}
                      className={`img-fluid w-100 ${
                        score == 1 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                    <img
                      src={quiz3}
                      className={`img-fluid w-100 ${
                        score == 2 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                    <img
                      src={quiz4}
                      className={`img-fluid w-100 ${
                        score == 3 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                    <img
                      src={quiz5}
                      className={`img-fluid w-100 ${
                        score == 4 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                    <img
                      src={quiz6}
                      className={`img-fluid w-100 ${
                        score == 5 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                    <img
                      src={quiz7}
                      className={`img-fluid w-100 ${
                        score == 6 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                    <img
                      src={quiz8}
                      className={`img-fluid w-100 ${
                        score == 7 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                    <img
                      src={quiz9}
                      className={`img-fluid w-100 ${
                        score == 8 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                    <img
                      src={quiz10}
                      className={`img-fluid w-100 ${
                        score == 9 ? "showFields" : "hideField"
                      }`}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="quiz-right-section h-100">
                <div className="quiz-inner-body">
                  <p>Question {score + 1} of 10</p>
                  <div className="steps">
                    {Array.from({ length: 10 }, (_, i) => (
                      <div
                        key={i + 1}
                        className={score + 1 >= i + 1 ? "active" : ""}
                      ></div>
                    ))}
                  </div>
                  <div className="quiz-question">
                    <h3>{quiz[currentQuestion].question}</h3>
                    <div className="quiz-answer">{renderOptions()}</div>
                    <div className="quiz-footer-btn">
                      {score > 0 && !spinLoading && (
                        <button className="btn" onClick={previousQuestion}>
                          Previous
                        </button>
                      )}
                      {score == 9 ? (
                        spinLoading ? (
                          <button className="cont-us" disabled>
                            Submit quiz
                            <CSpinner
                              color="light"
                              size="sm"
                              className={"ml-1"}
                            />{" "}
                          </button>
                        ) : (
                          <button className="cont-us" onClick={nextQuestion}>
                            Submit quiz
                          </button>
                        )
                      ) : (
                        //   <button className="cont-us" onClick={nextQuestion}>Submit quiz</button>
                        <button className="cont-us" onClick={nextQuestion}>
                          Next
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="modal-form thankyou-section">
          <div className="text-center head-section">
            <h2>Thank you!</h2>
            <p>
              Your quiz has been submitted. <br />
              We’re working on assigning an agent to you.
            </p>
          </div>
          <button
            className="cont-us"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => props.setIsModalOpen(false)}
          >
            Close
          </button>
          <img src={thankLogo} className="img-fluid" alt="" />
        </div>
      )}
    </>
  );
};

export default QuizStepper;
